import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import VuexORM from '@vuex-orm/core';
import VuexORMAxios from '@vuex-orm/plugin-axios';
import axios from '@services/api/axiosConfig';
import database from '@models/database';

import constants from './modules/constants';
import localization from './modules/localization';
import userArticles from './modules/userArticles';
import controllingCombo from './modules/controllingCombo';
import inputs from './modules/inputs';
import alert from './modules/alert';
import modalSettings from './modules/modalSettings';
import navigation from './modules/navigation';
import session from './modules/session';
import svg from './modules/svg';


import User from './modules/User';

import systemSelection from './modules/systemSelection';
import projectData from './modules/projectData';

Vue.use(Vuex);
const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage,
  reducer: (state) => {
    let newState = {...state};
    delete newState.constants;
    delete newState.inputs;
    delete newState.alert;
    delete newState.modalSettings;
    delete newState.svg;

    return newState;
  },
})

VuexORM.use(VuexORMAxios, {axios});
// TODO: Nicht genutze Stores enfernen
export default new Vuex.Store({
  plugins: [
    VuexORM.install(database),
    vuexLocal.plugin,
  ],
  modules: {
    constants,
    localization,
    userArticles,
    controllingCombo,
    inputs,
    alert,
    modalSettings,
    navigation,
    session,
    svg,

    systemSelection,

    User,
    projectData,
  },
  strict: false
});
